import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import useStyles from '../useStyles';

const Stepper = ({ label, value, min, max, step, wrap, pad, labels, onChange }) => {
  const classes = useStyles();
  const [typed, setTyped] = useState(null);

  const settled = typed
    ? Math.min(max, Math.max(min, Math.round(Number(typed) / step) * step))
    : value;

  const commit = (next) => {
    setTyped(null);
    if (next !== value) onChange(next);
  };

  // An off-step value lands on the nearest step in the direction of travel.
  const move = (up) => {
    const next = up
      ? Math.floor(settled / step) * step + step
      : Math.ceil(settled / step) * step - step;
    if (next > max) return commit(wrap ? min : max);
    if (next < min) return commit(wrap ? max : min);
    return commit(next);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') commit(settled);
    if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
    e.preventDefault();
    move(e.key === 'ArrowUp');
  };

  return (
    <label className={classes.control}>
      <span className={classes.caption}>{label}:</span>
      <span className={classes.stepper}>
        <input
          className={classes.stepperInput}
          inputMode="numeric"
          value={typed ?? String(value).padStart(pad, '0')}
          onFocus={(e) => e.target.select()}
          onChange={(e) => setTyped(e.target.value.replace(/\D/g, '').slice(0, String(max).length))}
          onBlur={() => commit(settled)}
          onKeyDown={onKeyDown}
        />
        <span className={classes.arrows}>
          <button
            type="button"
            className={classes.arrow}
            aria-label={`${labels.increase} ${label}`}
            disabled={!wrap && value >= max}
            onClick={() => move(true)}
          >
            <ExpandLessIcon />
          </button>
          <button
            type="button"
            className={classes.arrow}
            aria-label={`${labels.decrease} ${label}`}
            disabled={!wrap && value <= min}
            onClick={() => move(false)}
          >
            <ExpandMoreIcon />
          </button>
        </span>
      </span>
    </label>
  );
};

Stepper.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  wrap: PropTypes.bool,
  pad: PropTypes.number,
  labels: PropTypes.shape({
    increase: PropTypes.string.isRequired,
    decrease: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

Stepper.defaultProps = {
  step: 1,
  wrap: false,
  pad: 1,
};

export default Stepper;
